import {
  div,
  h1,
  span,
  button,
  fnstate,
  table,
  thead,
  tbody,
  tr,
  th,
  td,
  select,
  option,
  img
} from '@srfnstack/fntags'
import { createFetcher } from '../utils/api.js'

export const Orders = () => {
  const orders = fnstate([])
  const filterStatus = fnstate('')
  const page = fnstate(0)
  const limit = 20
  const loading = fnstate(true)

  const fetchOrders = createFetcher(
    () => fetch(`/api/orders?limit=${limit}&offset=${page() * limit}&status=${filterStatus()}&_=${Date.now()}`),
    orders,
    loading
  )

  const getStatusBadge = (status) => {
    const s = status.toLowerCase()
    if (s === 'fulfilled') return 'badge-success'
    if (s === 'canceled') return 'badge-error'
    if (s === 'pending') return 'badge-warning'
    if (s === 'in-production') return 'badge-info'
    return 'badge-ghost'
  }

  fetchOrders()

  return div({ class: 'p-6 space-y-6' },
    div({ class: 'flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4' },
      h1({ class: 'text-3xl font-bold' }, 'Order Management'),
      div({ class: 'flex gap-2 w-full sm:w-auto' },
        select({
          class: 'select select-bordered select-sm',
          onchange: (e) => {
            filterStatus(e.target.value)
            page(0)
            fetchOrders()
          }
        },
        option({ value: '' }, 'All Statuses'),
        option({ value: 'pending' }, 'Pending'),
        option({ value: 'in-production' }, 'In Production'),
        option({ value: 'fulfilled' }, 'Fulfilled'),
        option({ value: 'canceled' }, 'Canceled')
        ),
        button({ class: 'btn btn-outline btn-sm', onclick: fetchOrders }, 'Refresh')
      )
    ),

    div({ class: 'card bg-base-100 border border-base-300 shadow-sm overflow-hidden' },
      div({ class: 'overflow-x-auto' },
        table({ class: 'table w-full' },
          thead(
            tr(
              th('Order ID'),
              th('Date'),
              th('Status'),
              th('Total'),
              th('Items'),
              th('Actions')
            )
          ),
          tbody(
            loading.bindAs(l => l
              ? tr(td({ colspan: 6, class: 'text-center p-12' }, span({ class: 'loading loading-spinner loading-lg' })))
              : orders.bindAs(list => list.length === 0
                ? tr(td({ colspan: 6, class: 'text-center p-12 opacity-50' }, 'No orders found.'))
                : list.map(o => tr(
                  td(div({ class: 'flex flex-col' },
                    span({ class: 'font-bold' }, o.printify_order_id || `#${o.id}`),
                    o.etsy_order_id ? span({ class: 'text-[10px] opacity-50' }, `Etsy: ${o.etsy_order_id}`) : ''
                  )),
                  td({ class: 'text-xs' }, new Date(o.created_at).toLocaleString()),
                  td(span({ class: `badge badge-sm ${getStatusBadge(o.status)}` }, o.status)),
                  td(div({ class: 'flex flex-col' },
                    span({ class: 'font-bold' }, `$${Number(o.total_price).toFixed(2)}`),
                    span({ class: 'text-[10px] opacity-50' }, `${o.currency}`)
                  )),
                  td(div({ class: 'flex -space-x-3' },
                    (o.line_items || []).map(li => div({ class: 'tooltip', 'data-tip': li.design_title || 'Product' },
                      img({
                        src: li.upscaled_image ? `/api/image?file=${encodeURIComponent(li.upscaled_image)}` : '/images/placeholder.png',
                        class: 'w-8 h-8 rounded-full border-2 border-base-100 object-cover bg-base-300'
                      })
                    ))
                  )),
                  td(
                    button({
                      class: 'btn btn-ghost btn-xs',
                      onclick: () => window.open(`https://printify.com/app/store/orders/${o.printify_order_id}`)
                    }, 'View ↗')
                  )
                ))
              )
            )
          )
        )
      )
    ),

    // Pagination
    div({ class: 'flex justify-center items-center gap-4' },
      button({
        class: 'btn btn-sm',
        disabled: page.bindAttr(p => p === 0),
        onclick: () => { page(page() - 1); fetchOrders() }
      }, 'Prev'),
      span(page.bindAs(p => `Page ${p + 1}`)),
      button({
        class: 'btn btn-sm',
        disabled: orders.bindAttr(list => list.length < limit),
        onclick: () => { page(page() + 1); fetchOrders() }
      }, 'Next')
    )
  )
}
